import Vue from 'vue';

Vue.filter('timer', function(val, format = 'd _ hh:mm:ss')
{
  return val.format(format);
});
